import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination, // This is the component to move
  TableSortLabel,
  Tooltip,
  IconButton,
  Paper,
} from "@mui/material";
import DownloadingIcon from "@mui/icons-material/Downloading";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AutorenewIcon from "@mui/icons-material/Autorenew";

function DataGridAuditPlan({
  rows,
  initialText,
  page,
  size,
  totalRows,
  handleChangePage,
  handleChangeRowsPerPage,
  handleOpenStatusModal,
  handleOpenDeleteModal,
  handleOpenTransferDataRak2Modal,
  handleUpdateDataMobileToWebModal,
  handleEditClick,
  selectedProjectType,
  sortBy,
  sortOrder,
  onSortChange,
}) {
  const handleSort = (column) => {
    const newSortOrder =
      sortBy === column && sortOrder === "asc" ? "desc" : "asc";
    onSortChange(column, newSortOrder);
  };

  const tableHeaderStyle = {
    fontWeight: "bold",
    backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
    border: "solid 0.5px #fff",
    color: "#FFF",
    overflow: "hidden",
  };

  const actionTableHeaderStyle = {
    fontWeight: "bold",
    backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
    border: "solid 0.5px #fff",
    color: "#FFF",
  };

  const sortLabelStyle = {
    color: "#FFF !important",
    "&:hover": {
      color: "#FFF",
    },
    "& .MuiTableSortLabel-icon": {
      color: "#FFF !important",
    },
  };

  return (
    <Paper
      sx={{
        mt: 2,
        mb: 2,
        ml: 2,
        mr: 2,
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "calc(100vh - 250px)" }}
      >
        <Table stickyHeader aria-label="simple table" sx={{ minWidth: 3000 }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={actionTableHeaderStyle}>
                ACTIONS
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={sortBy === "store_code" ? sortOrder : false}
              >
                <TableSortLabel
                  active={sortBy === "store_code"}
                  direction={sortBy === "store_code" ? sortOrder : "asc"}
                  onClick={() => handleSort("store_code")}
                  sx={sortLabelStyle}
                >
                  KODE OUTLET
                </TableSortLabel>
              </TableCell>
              <TableCell align="center" style={tableHeaderStyle}>
                AUDIT PLAN
              </TableCell>
              <TableCell align="center" style={tableHeaderStyle}>
                NAMA OUTLET
              </TableCell>
              <TableCell align="center" style={tableHeaderStyle}>
                TIPE OUTLET
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={sortBy === "audit_status" ? sortOrder : false}
              >
                <TableSortLabel
                  active={sortBy === "audit_status"}
                  direction={sortBy === "audit_status" ? sortOrder : "asc"}
                  onClick={() => handleSort("audit_status")}
                  sx={sortLabelStyle}
                >
                  STATUS
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={
                  sortBy === "username_surveyor" ? sortOrder : false
                }
              >
                <TableSortLabel
                  active={sortBy === "username_surveyor"}
                  direction={sortBy === "username_surveyor" ? sortOrder : "asc"}
                  onClick={() => handleSort("username_surveyor")}
                  sx={sortLabelStyle}
                >
                  USERNAME SURVEYOR
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={
                  sortBy === "user_full_name_surveyor" ? sortOrder : false
                }
              >
                <TableSortLabel
                  active={sortBy === "user_full_name_surveyor"}
                  direction={
                    sortBy === "user_full_name_surveyor" ? sortOrder : "asc"
                  }
                  onClick={() => handleSort("user_full_name_surveyor")}
                  sx={sortLabelStyle}
                >
                  FULLNAME SURVEYOR
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={sortBy === "username_qc" ? sortOrder : false}
              >
                <TableSortLabel
                  active={sortBy === "username_qc"}
                  direction={sortBy === "username_qc" ? sortOrder : "asc"}
                  onClick={() => handleSort("username_qc")}
                  sx={sortLabelStyle}
                >
                  USERNAME QC
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={
                  sortBy === "user_full_name_qc" ? sortOrder : false
                }
              >
                <TableSortLabel
                  active={sortBy === "user_full_name_qc"}
                  direction={sortBy === "user_full_name_qc" ? sortOrder : "asc"}
                  onClick={() => handleSort("user_full_name_qc")}
                  sx={sortLabelStyle}
                >
                  FULLNAME QC
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={sortBy === "audit_start_at" ? sortOrder : false}
              >
                <TableSortLabel
                  active={sortBy === "audit_start_at"}
                  direction={sortBy === "audit_start_at" ? sortOrder : "asc"}
                  onClick={() => handleSort("audit_start_at")}
                  sx={sortLabelStyle}
                >
                  MULAI KUNJUNGAN
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={sortBy === "audit_end_at" ? sortOrder : false}
              >
                <TableSortLabel
                  active={sortBy === "audit_end_at"}
                  direction={sortBy === "audit_end_at" ? sortOrder : "asc"}
                  onClick={() => handleSort("audit_end_at")}
                  sx={sortLabelStyle}
                >
                  AKHIR KUNJUNGAN
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={sortBy === "created_at" ? sortOrder : false}
              >
                <TableSortLabel
                  active={sortBy === "created_at"}
                  direction={sortBy === "created_at" ? sortOrder : "asc"}
                  onClick={() => handleSort("created_at")}
                  sx={sortLabelStyle}
                >
                  TANGGAL DIBUAT
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                style={tableHeaderStyle}
                sortDirection={sortBy === "updated_at" ? sortOrder : false}
              >
                <TableSortLabel
                  active={sortBy === "updated_at"}
                  direction={sortBy === "updated_at" ? sortOrder : "asc"}
                  onClick={() => handleSort("updated_at")}
                  sx={sortLabelStyle}
                >
                  TANGGAL DIPERBARUI
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell align="center">
                    {selectedProjectType !== "adhoc" && (
                      <Tooltip title="Update Data Mobile to Website">
                        <IconButton
                          onClick={() => handleUpdateDataMobileToWebModal(row)}
                        >
                          <DownloadingIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {selectedProjectType === "rak1" && (
                      <Tooltip title="Transfer data to rak2">
                        <IconButton
                          onClick={() => handleOpenTransferDataRak2Modal(row)}
                        >
                          <MoveDownIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {(row.audit_status === "Not Started" ||
                      row.audit_status === "Valid" ||
                      row.audit_status === "On Progress") && (
                      <>
                        <Tooltip title="Edit Audit Plan">
                          <IconButton onClick={() => handleEditClick(row.id)}>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Audit Plan">
                          <IconButton
                            onClick={() => handleOpenDeleteModal(row.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                    {(row.audit_status === "Closed" ||
                      row.audit_status === "closed") && (
                      <Tooltip title="Update Audit Plan to Valid">
                        <IconButton
                          onClick={() => handleOpenStatusModal(row.id, "Valid")}
                        >
                          <AutorenewIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {row.audit_status === "Valid" && (
                      <Tooltip title="Update Audit Plan to Closed">
                        <IconButton
                          onClick={() =>
                            handleOpenStatusModal(row.id, "Closed")
                          }
                        >
                          <AutorenewIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell align="center">{row.store_code}</TableCell>
                  <TableCell align="center">{row.audit_plan}</TableCell>
                  <TableCell align="center">{row.store_name}</TableCell>
                  <TableCell align="center">{row.store_type}</TableCell>
                  <TableCell align="center">
                    <div
                      style={{
                        background:
                          row.audit_status === "Valid"
                            ? "lightblue"
                            : row.audit_status === "Not Started"
                            ? "red"
                            : row.audit_status === "Closed"
                            ? "green"
                            : row.audit_status === "On Progress"
                            ? "orange"
                            : "grey",
                        color: "white",
                        padding: "5px",
                        borderRadius: "4px",
                      }}
                    >
                      {row.audit_status}
                    </div>
                  </TableCell>
                  <TableCell align="center">{row.user_name_surveyor}</TableCell>
                  <TableCell align="center">
                    {row.user_full_name_surveyor}
                  </TableCell>
                  <TableCell align="center">{row.user_name_qc}</TableCell>
                  <TableCell align="center">{row.user_full_name_qc}</TableCell>
                  <TableCell align="center">{row.audit_start_at}</TableCell>
                  <TableCell align="center">{row.audit_end_at}</TableCell>
                  <TableCell align="center">{row.created_at}</TableCell>
                  <TableCell align="center">{row.updated_at}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={14} align="center">
                  {initialText}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalRows}
        page={page - 1}
        onPageChange={handleChangePage}
        rowsPerPage={size}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />
    </Paper>
  );
}

export default DataGridAuditPlan;
